import { useState } from 'react';
import { Share2, Link2, Check, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function ShareButtons({ title, text }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const message = `${title} — Andrea Caruso Fotografo\n${text ? text + '\n' : ''}${url}`;
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link copiato! Incollalo su Instagram, nelle Storie o dove vuoi');
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      toast.error('Impossibile copiare il link');
    }
  };

  const nativeShare = async () => {
    try {
      await navigator.share({ title: `${title} — Andrea Caruso Fotografo`, text: text || title, url });
    } catch (e) {
      if (e?.name !== 'AbortError') copyLink();
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="text-sm text-muted-foreground mr-1">Condividi:</span>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp-btn"
      >
        <Button type="button" variant="outline" size="sm" className="rounded-full">
          <MessageCircle size={15} className="mr-1.5" /> WhatsApp
        </Button>
      </a>
      <Button type="button" variant="outline" size="sm" className="rounded-full" onClick={copyLink} data-testid="share-copy-btn">
        {copied ? <Check size={15} className="mr-1.5" /> : <Link2 size={15} className="mr-1.5" />}
        {copied ? 'Copiato' : 'Copia link'}
      </Button>
      {canNativeShare && (
        <Button type="button" variant="outline" size="sm" className="rounded-full" onClick={nativeShare} data-testid="share-native-btn">
          <Share2 size={15} className="mr-1.5" /> Altro (Instagram, ...)
        </Button>
      )}
    </div>
  );
}
